export default __webpack_public_path__ + "static/media/arrow-right.2449c4b7.svg";